import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";

const joinFamilyCallable = httpsCallable(functions, "joinFamilyByCode");

export const needsKidReplace = (error) =>
  String(error?.code || "").includes("failed-precondition");

export const callJoinFamilyByCode = async ({ code, name, forceReplace = false }) => {
  const result = await joinFamilyCallable({
    code: String(code || "").trim(),
    name: String(name || "").trim(),
    forceReplace
  });
  return result?.data || {};
};

